import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { animeArticles } from "@/mocks/animeData";

export default function LatestArticles() {
  const { t } = useTranslation();
  const latest = animeArticles.slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="container-site">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {t("home.latestTitle")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            {t("home.latestSubtitle")}
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
            >
              <div className="flex-shrink-0 w-24 h-24 md:w-28 md:h-28 rounded-md overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 font-heading">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-2 line-clamp-2">
                    {article.excerpt}
                  </p>
                </div>
                <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center gap-2">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700">
                      {article.category}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-500">{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-500 transition-all duration-200 cursor-pointer"
          >
            {t("home.viewMore")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}